import { i18n } from "@/plugins/i18n";
import mixins from "@/mixins";

export class Deposit {
  columns = [];
  id = "id";

  fillAbles = [
    ["name", i18n.t("name"), true],
    [
      "depositType.name",
      mixins.projectTenant() === "Candle"
        ? i18n.t("reasonFor")
        : i18n.t("depositType"),
      true,
    ],
    ["safeboxId", i18n.t("safeboxId"), true, false],
    ["mcPrice", i18n.t("mcPrice"), true],
    ["accountant", i18n.t("accountant"), true],
    ["depositer", i18n.t("depositer"), true],
    ["date", i18n.t("date"), true],
    ["note", i18n.t("note"), true],
    ["attachment", i18n.t("attachment"), true],
    ["controls", i18n.t("controls"), false],
  ];

  getColumns() {
    this.columns = [
      {
        label: i18n.t("id"),
        name: "id",
        sort: false,
        visibility:
          process.env.VUE_APP_PROJECT_NAME === "MassHills" ? false : true,
        uniqueId: true,
      },
    ];
    this.fillAbles.map((e) => {
      this.columns.push({
        name: e[0],
        label: e[1],
        sort: e[2],
        visibility: e[3] ?? true,
      });
    });
    return this.columns;
  }
}
